export default [
    // packages ordered by priority
    "PFPF",
    "PFF",
    "HF",

    "PFPCS",
    "PFCS",

    "PFPTT",
    "PFPTTF",
    "PFPTTNL",

    "PFTT",
    "PFTTNL",
    "PFTTF",
    
    "HTT",
    "HTTF",
    "HTTNL",

    "PFP",
    "PF",
    "HS",

];
